import { ref, watch } from 'vue'
import client from '@/composables/homebaseClient'

export default function useHomebaseUsers(initialParams = {}) {
    const users = ref([])
    const loading = ref(false)
    const error = ref(null)

    const params = ref({
        limit: 100,
        ...initialParams
    })

    const toQuery = () => {
        const q = new URLSearchParams()
        if (params.value.limit) q.set('limit', String(params.value.limit))
        return q.toString() ? `?${q.toString()}` : ''
    }

    const fetchUsers = async () => {
        loading.value = true
        error.value = null
        try {
            const res = await client.get(`/users${toQuery()}`)
            users.value = Array.isArray(res.data) ? res.data : []
        } catch (err) {
            error.value = err.detail || 'Failed to load users'
        } finally {
            loading.value = false
        }
    }

    const createUser = async (userData) => {
        try {
            const res = await client.post('/users', userData)
            await fetchUsers() // refresh list
            return res.data
        } catch (err) {
            throw new Error(err.detail || 'Failed to create user')
        }
    }

    const updateUserPassword = async (userId, newPassword) => {
        try {
            const res = await client.patch(`/users/${userId}`, {
                password: newPassword
            })
            return res.data
        } catch (err) {
            throw new Error(err.detail || 'Failed to update password')
        }
    }

    const deleteUser = async (userId) => {
        try {
            await client.delete(`/users/${userId}`)
            await fetchUsers() // refresh list
            return true
        } catch (err) {
            throw new Error(err.detail || 'Failed to delete user')
        }
    }

    const getUser = async (userId) => {
        try {
            const res = await client.get(`/users/${userId}`)
            return res.data
        } catch (err) {
            throw new Error(err.detail || 'Failed to get user')
        }
    }

    // Auto-fetch when params change
    watch(params, fetchUsers, { deep: true })

    return {
        users,
        loading,
        error,
        params,
        fetchUsers,
        createUser,
        updateUserPassword,
        deleteUser,
        getUser
    }
}



